// extracted by mini-css-extract-plugin
export default {"sideMenu":"SideMenu_sideMenu__cHa5Q","rootItem":"SideMenu_rootItem__SV7v2"};